var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.sectionContent }, [
    _c("div", { class: _vm.$style.detailsRow }, [
      _c("div", { class: _vm.$style.detailsLabel }, [_vm._v(" Company Name ")]),
      _c("div", { class: _vm.$style.detailsValue }, [
        _vm._v(" " + _vm._s(_vm.entity.name) + " "),
      ]),
    ]),
    _c("div", { class: _vm.$style.detailsRow }, [
      _c("div", { class: _vm.$style.detailsLabel }, [_vm._v(" Industry ")]),
      _c("div", { class: _vm.$style.detailsValue }, [
        _vm._v(" " + _vm._s(_vm.industry) + " "),
      ]),
    ]),
    _c("div", { class: _vm.$style.detailsRow }, [
      _c("div", { class: _vm.$style.detailsLabel }, [_vm._v(" Address ")]),
      _c("div", { class: _vm.$style.detailsValue }, [
        _vm._v(" " + _vm._s(_vm.address || "-") + " "),
      ]),
    ]),
    _c("div", { class: _vm.$style.detailsRow }, [
      _c("div", { class: _vm.$style.detailsLabel }, [_vm._v(" Company URL ")]),
      _vm.website
        ? _c("div", { class: _vm.$style.detailsValue }, [
            _c(
              "a",
              {
                class: _vm.$style.website,
                attrs: { href: _vm.website, target: "_blank" },
              },
              [_vm._v(" " + _vm._s(_vm.website) + " ")]
            ),
          ])
        : _c("div", { class: _vm.$style.detailsValue }, [_vm._v(" - ")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }